import React, { useEffect } from 'react';
import axiosPrivate from 'config/axiosPrivate';
import { useHistory, useLocation } from 'react-router-dom';

const ACTIVATION_URL = '/user/auth/account-activation';

export default function AccountActivation() {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const params = new URLSearchParams(location.search);
    const mail = params.get('mail');
    const otpNum = params.get('otpNum');

    if (!mail || !otpNum) {
      history.replace('/account-activation-error');
      return undefined;
    }

    axiosPrivate
      .get(ACTIVATION_URL, {
        params: { mail, otpNum },
      })
      .then(() => {
        if (isMounted) {
          history.replace('/login');
        }
      })
      .catch(() => {
        if (isMounted) {
          history.replace('/account-activation-error');
        }
      });

    return () => {
      isMounted = false;
    };
  }, [history, location.search]);

  return (
    <div>
  
    </div>
  );
}
